module.exports = "void main() {\ngl_FragColor = vec4(0.0, 0.0, 0.0, 0.0);\n}"